var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8035 6.86914C16.4207 6.86914 17.9716 7.51155 19.1152 8.65506C20.2587 9.79856 20.9011 11.3495 20.9011 12.9666V20.0804H16.836V12.9666C16.836 12.4276 16.6219 11.9106 16.2407 11.5294C15.8595 11.1483 15.3425 10.9341 14.8035 10.9341C14.2644 10.9341 13.7474 11.1483 13.3662 11.5294C12.9851 11.9106 12.7709 12.4276 12.7709 12.9666V20.0804H8.70581V12.9666C8.70581 11.3495 9.34824 9.79856 10.4918 8.65506C11.6353 7.51155 13.1863 6.86914 14.8035 6.86914Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64087 7.88574H0.575684V20.0807H4.64087V7.88574Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60815 4.83844C3.73066 4.83844 4.64062 3.92846 4.64062 2.80594C4.64062 1.68342 3.73066 0.773438 2.60815 0.773438C1.48565 0.773438 0.575684 1.68342 0.575684 2.80594C0.575684 3.92846 1.48565 4.83844 2.60815 4.83844Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.e776fdf3f9334a7c318e6948afe0b400.svg";
export { ForwardRef as ReactComponent };